import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { ChevronsUpDown, Check } from "lucide-react";

const GROUPS = ["इसी सत्संग घर के", "आस-पास (इसी केंद्र समूह के)", "अन्य सभी"];

// plain text search: name starting with the typed text first, then any word, then anywhere
const filter = (value, search) => {
  const v = value.toLowerCase();
  const s = search.trim().toLowerCase();
  if (!s) return 1;
  if (v.startsWith(s)) return 1;
  if (v.split(/[\s·]+/).some((w) => w.startsWith(s))) return 0.8;
  return v.includes(s) ? 0.5 : 0;
};

// Searchable + scrollable picker. options: [{ value, label, search, rank }]
export const PersonPicker = ({ value, onChange, options, extra = [], testid, placeholder = "चुनें" }) => {
  const [open, setOpen] = useState(false);
  const all = [...extra, ...options];
  const current = all.find((o) => o.value === value);
  const pick = (v) => {
    onChange(v);
    setOpen(false);
  };
  const item = (o) => (
    <CommandItem
      key={o.value}
      value={`${o.label.replace(/^(श्रीमती|श्री|कुमारी)\s*/, "")} ${o.search || ""} ${o.value}`}
      onSelect={() => pick(o.value)}
      data-testid={`${testid}-option-${o.value}`}
      className="font-dev cursor-pointer"
    >
      <Check className={`w-4 h-4 shrink-0 ${o.value === value ? "opacity-100" : "opacity-0"}`} />
      <div className="min-w-0">
        <div>{o.label}</div>
        {o.warn && (
          <div data-testid={`${testid}-busy-${o.value}`} className={`text-[11px] font-semibold ${o.warn === "clash" ? "text-red-700" : "text-amber-700"}`}>
            {o.warn === "clash" ? "⚠ इसी समय सेवा: " : "इस दिन सेवा: "}
            {o.note}
          </div>
        )}
      </div>
    </CommandItem>
  );
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="mt-1 w-full flex items-center justify-between gap-2 rounded-md border border-[#e3d6b6] bg-[#f6eeda] px-3 py-2 text-sm text-left font-dev text-[#3a1212]"
        >
          <span className="truncate">{current?.label || placeholder}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[280px] bg-[#fffdf7] border-[#cdb98f]" align="start">
        <Command filter={filter}>
          <CommandInput data-testid={`${testid}-search`} placeholder="नाम, जगह या मोबाइल से खोजें (हिंदी/English)" className="font-dev" />
          <CommandList className="max-h-72">
            <CommandEmpty className="py-4 text-center text-sm font-dev">कोई नहीं मिला</CommandEmpty>
            {extra.length > 0 && <CommandGroup>{extra.map(item)}</CommandGroup>}
            {GROUPS.map((h, r) => {
              const list = options.filter((o) => o.rank === r);
              return list.length ? (
                <CommandGroup key={h} heading={h}>
                  {list.map(item)}
                </CommandGroup>
              ) : null;
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
